import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GET_CHART_DATA } from '../api';
import { PieChart } from './PieChart';
import { Loader } from '../../../components/Loader';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { useQuery } from '@apollo/client';
import { sortData } from '../utils';

export const PieGrid = (props: any) => {
  const { user } = useSelector((state: any) => ({ user: state.user }));
  const [sortOrder, setSortOrder] = React.useState(props.orderVal);
  const [sortType, setSortType] = React.useState(props.sortType);

  const getAssetFilter = () => {
    let assetFilter: any = { assetTableEntry: true, isDeleted: false, source: user.currentRole.source };
    if (props.isAdmin) return assetFilter;
    else {
      assetFilter.DepartmentID = props.departments[0].id;
      return assetFilter;
    }
  };

  const { data, loading, error } = useQuery(GET_CHART_DATA, { variables: { assetFilter: getAssetFilter() }, fetchPolicy: 'network-only' });
  
  if (loading) return <Loader title='Loading Pie Charts...' />;
  // if (error) return <div>{JSON.stringify(error)}</div>;
  if(error) return <div>{error}</div>

  let chartData = sortData(data.chartData, sortOrder, sortType);

  //console.log(chartData);
  return (
    <div>
      <div style={{ textAlign: 'right' }}>
        <label htmlFor='sortType'>Sort by </label>
        <select name='sortType' onChange={(e) => setSortType(e.target.value)} value={sortType} className='ml-1'>
          <option value='total'>Total Number of Items</option>
          <option value='scanned'>Number Scanned Items</option>
          <option value='percent'>Percent Complete</option>
          <option value='name'>Department Name</option>
        </select>
        <ToggleButtonGroup name='pieChartSort' type='checkbox' className='p-1' value={sortOrder} onChange={() => setSortOrder(3 - sortOrder)}>
          <ToggleButton variant='light' value={1} size='sm'>
            <i className='fas fa-arrow-alt-circle-up' />
          </ToggleButton>
          <ToggleButton variant='light' value={2} size='sm'>
            <i className='fas fa-arrow-alt-circle-down' />
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
      <div className='cardContent'>
        <div className='pie-grid-container'>
          {chartData.map((item, index) => {
            if(index == 0) {console.log('item: ', item)}
            return (
            <PieChart departmentStats={item} key={index} />
          )})}
        </div>
      </div>
    </div>
  );
};
